/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse, HttpContext } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

/**
 * Reporting endpoints.
 */
@Injectable({
  providedIn: 'root',
})
export class ReportsService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /**
   * Path part for operation getAvailableReportTypes
   */
  static readonly GetAvailableReportTypesPath = '/reports';

  /**
   * The list of available report types.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getAvailableReportTypes()` instead.
   *
   * This method doesn't expect any request body.
   */
  getAvailableReportTypes$Response(
    params?: {},
    context?: HttpContext
  ): Observable<
    StrictHttpResponse<
      Array<
        | 'MERCHANTS_WITH_DELIVERY_METHODS'
        | 'PURCHASE_IN_LAST_30_DAYS'
        | 'PUBLISHED_PRODUCTS'
        | 'TENDERS'
        | 'DISCOUNTS'
      >
    >
  > {
    const rb = new RequestBuilder(
      this.rootUrl,
      ReportsService.GetAvailableReportTypesPath,
      'get'
    );
    if (params) {
    }

    return this.http
      .request(
        rb.build({
          responseType: 'json',
          accept: 'application/json',
          context: context,
        })
      )
      .pipe(
        filter((r: any) => r instanceof HttpResponse),
        map((r: HttpResponse<any>) => {
          return r as StrictHttpResponse<
            Array<
              | 'MERCHANTS_WITH_DELIVERY_METHODS'
              | 'PURCHASE_IN_LAST_30_DAYS'
              | 'PUBLISHED_PRODUCTS'
              | 'TENDERS'
              | 'DISCOUNTS'
            >
          >;
        })
      );
  }

  /**
   * The list of available report types.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getAvailableReportTypes$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getAvailableReportTypes(
    params?: {},
    context?: HttpContext
  ): Observable<
    Array<
      | 'MERCHANTS_WITH_DELIVERY_METHODS'
      | 'PURCHASE_IN_LAST_30_DAYS'
      | 'PUBLISHED_PRODUCTS'
      | 'TENDERS'
      | 'DISCOUNTS'
    >
  > {
    return this.getAvailableReportTypes$Response(params, context).pipe(
      map(
        (
          r: StrictHttpResponse<
            Array<
              | 'MERCHANTS_WITH_DELIVERY_METHODS'
              | 'PURCHASE_IN_LAST_30_DAYS'
              | 'PUBLISHED_PRODUCTS'
              | 'TENDERS'
              | 'DISCOUNTS'
            >
          >
        ) =>
          r.body as Array<
            | 'MERCHANTS_WITH_DELIVERY_METHODS'
            | 'PURCHASE_IN_LAST_30_DAYS'
            | 'PUBLISHED_PRODUCTS'
            | 'TENDERS'
            | 'DISCOUNTS'
          >
      )
    );
  }

  /**
   * Path part for operation getReport
   */
  static readonly GetReportPath = '/reports/{type}';

  /**
   * Get the specific resource in CSV.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getReport()` instead.
   *
   * This method doesn't expect any request body.
   */
  getReport$Response(
    params: {
      type:
        | 'MERCHANTS_WITH_DELIVERY_METHODS'
        | 'PURCHASE_IN_LAST_30_DAYS'
        | 'PUBLISHED_PRODUCTS'
        | 'TENDERS'
        | 'DISCOUNTS';
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<string>> {
    const rb = new RequestBuilder(
      this.rootUrl,
      ReportsService.GetReportPath,
      'get'
    );
    if (params) {
      rb.path('type', params.type, {});
    }

    return this.http
      .request(
        rb.build({
          responseType: 'text',
          accept: 'text/csv',
          context: context,
        })
      )
      .pipe(
        filter((r: any) => r instanceof HttpResponse),
        map((r: HttpResponse<any>) => {
          return r as StrictHttpResponse<string>;
        })
      );
  }

  /**
   * Get the specific resource in CSV.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getReport$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getReport(
    params: {
      type:
        | 'MERCHANTS_WITH_DELIVERY_METHODS'
        | 'PURCHASE_IN_LAST_30_DAYS'
        | 'PUBLISHED_PRODUCTS'
        | 'TENDERS'
        | 'DISCOUNTS';
    },
    context?: HttpContext
  ): Observable<string> {
    return this.getReport$Response(params, context).pipe(
      map((r: StrictHttpResponse<string>) => r.body as string)
    );
  }
}
